import { Box, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import theme from "../../../theme";

type Props = {
  amount: string;
  amountColor?: string;
  label: string;
};

export const NumberBlock = ({ amount, amountColor, label }: Props) => {
  return (
    <Box
      sx={{
        margin: 1,
        padding: "10px",
        border: `1px solid ${theme.palette.secondary.light}`,
        borderRadius: "8px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "rgba(74, 29, 156, 0.04)",
      }}
    >
      <Typography
        variant="header"
        sx={{
          color: amountColor,
          fontWeight: 700,
          fontSize: "40px",
          letterSpacing: "2px",
        }}
      >
        {amount}
      </Typography>
      <Typography sx={{ paddingTop: "16px" }}>{label}</Typography>
      <ChevronRightIcon color="primary" />
    </Box>
  );
};
